"use client"
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'
import { configureBoneyard } from 'boneyard-js/react'

import _hero_swipper from './hero-swipper.bones.json'
import _seller_card from './seller-card.bones.json'
import _artwork_card from './artwork-card.bones.json'
import _about_seller from './about-seller.bones.json'
import _details_page from './details-page.bones.json'
import _profile_info from './profile-info.bones.json'
import _stat_card from './stat-card.bones.json'

configureBoneyard({"color":"#ece8de","darkColor":"#222222","animate":"shimmer","shimmerColor":"#f5f1e8","darkShimmerColor":"#2c2c2c","speed":"1.6s","shimmerAngle":110,"stagger":false,"transition":200})

registerBones({
  "hero-swipper": _hero_swipper,
  "seller-card": _seller_card,
  "artwork-card": _artwork_card,
  "about-seller": _about_seller,
  "details-page": _details_page,
  "profile-info": _profile_info,
  "stat-card": _stat_card,
})
